module.exports = __webpack_public_path__ + "img/logo-aiTongChuan-dark-mode.4ba86ac9.svg";